import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import { Select as NCSelect, Checkbox as NCCheckbox, Table as NCTable } from '@platform/base';
// import { ListToListTransfer } from '@platform/components';
import { ListToListTransfer } from '../../components/Transfer';


const NCOption = NCSelect.Option;
const sort = NCTable.sort;
const multiSelect = NCTable.multiSelect;
const MetaTable = sort(NCTable, NCCheckbox);


//穿梭框模拟数据
const mockData = [];
for (let i = 0; i < 80; i++) {
    mockData.push({
        key: i.toString(),
        title: `content${i + 1}`,
        description: `description of content${i + 1}`,
        disabled: (i % 3 < 1) || (i == 2),
    });
}

const targetDataSource = JSON.parse(JSON.stringify(mockData.filter(item => +item.key % 3 > 1)));
const exchangeMode = 'move';
targetDataSource.forEach((item, index) => {
    item._key = item.key + '_' + index;
});
const targetKeys = targetDataSource.map(item => exchangeMode === 'copy' ? item._key : item.key);

export default class SortTab extends Component {
    constructor(props) {
        super(props);
        this.state = { checked: false,targetKeys: targetKeys,targetDataSource: targetDataSource,rowIndex:-1 }
    }
    logicSelectChange = (index, value, oldValue) => {
        let row = this.filterData[index];
        row.ordertype = value;
        if (value === '0') {
            row._disabled = true;
            row._checked = false;
        }
        if(this.props.searchInfo && this.props.searchInfo.sortField){
            if(this.props.searchInfo.sortField[index]){
               this.props.searchInfo.sortField[index].ordertype = value;
            }
        }
        this.forceUpdate();
    }
    moveChange = (direction, record, index) => {
        let row = this.filterData[index];
        let originalData = [...this.props.data];
        let originalIndex = originalData.findIndex(i => i.refcode === row.refcode);
        switch (direction) {
            case 'up':
                if (index === 0) {
                    return;
                }
                let upRow = this.filterData[index - 1];
                let upIndex = originalData.findIndex(i => i.refcode === upRow.refcode);
                originalData.splice(originalIndex, 1);
                originalData.splice(upIndex, 0, record);
                break;
            case 'down':
                if (index === this.filterData.length - 1) {
                    return;
                }
                let downRow = this.filterData[index + 1];
                let downIndex = originalData.findIndex(i => i.refcode === downRow.refcode);
                originalData.splice(originalIndex, 1);
                originalData.splice(downIndex, 0, record);
                break;
            default:
                break;
        }
        const sortDataChange = this.props.sortDataChange;
        typeof sortDataChange === 'function' && sortDataChange(originalData);
    }
    columns = () => {
        let multiLang = this.props.multiLang;
        let that = this;
        return [
            {
                title: multiLang['page-search-0135'] || "序号", dataIndex: "index", isSort: false, key: "index", width: 55, fixed: 'left', render(text, record, index, column) {
                    return index + 1
                }
            },
            { title: multiLang['page-search-0136'] || "排序字段", dataIndex: "refname", isSort: false, key: "refname", width: 180 },
            {
                // 0-不排序、1-正序、2-倒序
                title: multiLang['page-search-0137'] || "排序方式", dataIndex: "ordertype", isSort: false, key: "ordertype", width: 260, render(text, record, index, column) {
                    return <NCSelect
                        className="ordertype"
                        showClear={false}
                        value={String(text)}
                        onChange={that.logicSelectChange.bind(that, index)}
                    >
                        <NCOption key='0' value='0'> {multiLang['page-search-0138'] || '不排序'}</NCOption>
                        <NCOption key='1' value='1'> {multiLang['page-search-0139'] ||'正序'}</NCOption>
                        <NCOption key='2' value='2'> {multiLang['page-search-0140'] ||'倒序'}</NCOption>
                    </NCSelect>
                }
            },
            {
                title: multiLang['page-search-0143'] || "操作", dataIndex: "opr", key: "opr", width: 180, fixed: 'right', render(text, record, index, column) {
                    let moveUpClass = index == 0 ? 'move move_disabled' : 'move';
                    let moveDownClass = index == that.filterData.length - 1 ? 'move move_disabled' : 'move';
                    return <div className='opr_order'><span className={moveUpClass} onClick={that.moveChange.bind(that, 'up', record, index)} style={{ marginRight: '12px' }}>{multiLang['page-search-0141'] || "上移"}</span><span className={moveDownClass} onClick={that.moveChange.bind(that, 'down', record, index)}>{multiLang['page-search-0142'] || "下移"}</span></div >
                }
            },
        ]
    }
    getSelectedDataFunc = (selectedList, record, index) => {
        let data = this.props.data;
        let selectedSet = new Set(selectedList.map(i => i.refcode));
        let newData = data.map(i => {
            i._checked = selectedSet.has(i.refcode) ? true : false;
            return { ...i };
        })
        const sortDataChange = this.props.sortDataChange;
        typeof sortDataChange === 'function' && sortDataChange(newData);
    }
    onDropRow = (data, record, dropTargetIndex) => {
        let row = this.filterData[dropTargetIndex];
        let originalData = [...this.props.data];
        let originalIndex = originalData.findIndex(i => i.refcode === row.refcode);
        let targetIndex = originalData.findIndex(i => i.refcode === record.refcode);
        originalData.splice(targetIndex, 1);
        originalData.splice(originalIndex, 0, record);
        // console.log('重排序后的data： ', data, originalData, originalData.filter(i => i.ordertype !== '0'));
        // console.log('拖拽的行数据： ', record);
        const sortDataChange = this.props.sortDataChange;
        typeof sortDataChange === 'function' && sortDataChange(originalData);
    }
    onChange = (checked) => {
        this.setState({ checked: checked });
    }
    onTargetKeysChange = (targetKeys, direction, moveKeys, dataSource, targetDataSource) => {
        console.log(targetKeys, direction, moveKeys, dataSource, targetDataSource);
        
        this.setState({
            targetKeys,
            targetDataSource,
        });
    };

    // 表格行的className
    rowClassName = (record, index) => {
        let { rowIndex } = this.state,
            className = '';
        if (rowIndex === index) {
            className += ' search-focus-row';
        }
        return className.trim();
    };

    render() {
        let data = this.props.data || [];
        let multiLang = this.props.multiLang;
        let checked = this.state.checked;
        //处理data
        let filterData = data.filter(item => {
            item.key = item.refcode;
            let ordertype = item.ordertype;
            if (ordertype === '0') {
                item._disabled = true;
                item._checked = typeof item._checked !== 'undefined' ? item._checked : false;
            } else {
                item._disabled = false;
                item._checked = typeof item._checked !== 'undefined' ? item._checked : true;
            }
            if (checked) {
                return ordertype !== '0';
            } else {
                return true;
            }

        })
        this.filterData = filterData;
        return <div className='sortTab'>
            <MetaTable
                columns={this.columns()}
                data={filterData}
                className='sortTable'
                height={30}
                lazyload={false}
                headerHeight={30}
                autoCheckedByClickRows={false}
                addBlankCol={false}
                rowDraggAble={true}
                useDragHandle={true}
                scroll={{ y: 322 }}
                bodyStyle={{ minHeight: 322 }}
                dragborder={true}
                // sort={sortObj}
                getSelectedDataFunc={this.getSelectedDataFunc}
                onDropRow={this.onDropRow}
                rowClassName={this.rowClassName}
                onRowHover={(index) => {
                    this.setState({
                        rowIndex: index,
                        // selectedRowIndex: index,
                    });
                }}
            />
            <div className='sort_filter'>
                <NCCheckbox checked={this.state.checked} onChange={this.onChange}>{multiLang['page-search-0134'] || '只显示排序选项'}</NCCheckbox>
            </div>
            {/* <ListToListTransfer
                className="xxx-transfer"
                dataSource={mockData}
                titles={['Source', 'Target']}
                targetKeys={this.state.targetKeys}
                targetDataSource={this.state.targetDataSource}
                targetItemKey={'_key'}
                sourceItemCacheKey={'_cacheKey'}
                // exchangeMode={this.state.exchangeMode}
                // selectedKeys={this.state.selectedKeys}
                // onChange={this.handleChange}
                // onSelectChange={this.handleSelectChange}
                // onScroll={this.handleScroll}
                // showMoveBtn={false}
                // draggable
                dragOffset
                //这里穿梭框可以进行自定义render，渲染想要展示的样式
                render={item => <span><span>{item.title}</span><span style={{marginRight:'10px',float:'right'}}>倒序</span></span>}
                onTargetKeysChange={this.onTargetKeysChange}
            /> */}
        </div >
    }
}

